import { gql } from '@apollo/client';
const GET_PRODUCT_FUNCTIONS = gql `
  query GetProductFunctions($first: Int = 25, $after: String = "") {
    autocomplete {
      productFunctions(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_FUNCTIONS;
